export * from './contact'
export * from './custom'
export * from './dashboard'
export * from './profile'
export * from './modal'
export * from './toast'
export * from './pusher'
export * from './changeRequest'

export const statusType = {
  IDLE: 'IDLE',
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR'
}
